var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99967 4.79159C4.72341 4.79159 4.45846 4.68184 4.2631 4.48649C4.06775 4.29114 3.95801 4.02619 3.95801 3.74992C3.95801 3.47365 4.06775 3.2087 4.2631 3.01335C4.45846 2.818 4.72341 2.70825 4.99967 2.70825C5.27594 2.70825 5.54089 2.818 5.73624 3.01335C5.93159 3.2087 6.04134 3.47365 6.04134 3.74992C6.04134 3.88671 6.0144 4.02217 5.96205 4.14855C5.9097 4.27493 5.83297 4.38976 5.73624 4.48649C5.63952 4.58322 5.52468 4.65994 5.3983 4.71229C5.27192 4.76464 5.13647 4.79159 4.99967 4.79159ZM4.99967 0.833252C4.22613 0.833252 3.48426 1.14054 2.93728 1.68752C2.3903 2.2345 2.08301 2.97637 2.08301 3.74992C2.08301 5.93742 4.99967 9.16658 4.99967 9.16658C4.99967 9.16658 7.91634 5.93742 7.91634 3.74992C7.91634 2.97637 7.60905 2.2345 7.06207 1.68752C6.51509 1.14054 5.77322 0.833252 4.99967 0.833252Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiLocation);
export default __webpack_public_path__ + "static/media/mdi_location.6ad688a4007d35f4279cda6108ef464b.svg";
export { ForwardRef as ReactComponent };